import { useEffect, useState } from "react"
import {Container,AppBar,Toolbar,Box,Typography, Grid, Grid2, CircularProgress, InputAdornment} from "@mui/material"
import { Autocomplete, Button, Divider, Stack, Chip, Grow, IconButton, Modal, TextField, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, useMediaQuery } from "@mui/material";
import styles from "./mainLayout.module.css"

import styles1 from "../components/Dashboard.module.css"

import Login from "../components/Login"
import Accounts from "../components/Accounts"
import ApiClient from "../utilities/apiClient"
import AppConfig from "../utilities/appConfig"

import CryptoJS from "crypto-js"

import CloseIcon from "@mui/icons-material/Close";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import {createTheme, ThemeProvider } from '@mui/material/styles';  


import navLogo from "../assets/svg/tradebossnavlogo.svg"
import Dashboard from "../components/Dashboard"
import Card from "../components/Card"


import wvFour from "../assets/svg/wvFour.png"

import cardlogo from "../assets/svg/modallogo.svg"
import { useNavigate } from "react-router-dom";
import { ArrowDropUp,ArrowDropDown} from "@mui/icons-material";

export default function MainLayout(){

    const navigate1 = useNavigate()

    if(localStorage.getItem("data")?.startsWith("{")){
        localStorage.clear()
        navigate1("/")
    }

    const smallScreen = useMediaQuery("(max-width : 700px)")
    const smallScreen1 = useMediaQuery("(max-width : 500px)")
    const smallScreen2 = useMediaQuery("(max-width : 520px)")
    const [user, setUser] = useState(() => {
        try {
            const accountsString = localStorage.getItem("accounts");
            const accounts = accountsString ? JSON.parse(accountsString) : [];
            return accounts[0] || {};
        } catch (err) {
            console.error("Failed to parse accounts:", err);
            return {};
        }
    });


   

//   const setPaymentStatusModel = (secret) => {
//     console.log(secret , "secret")
//     console.log("payment status model")
//     const queryString = window.location.search;
//     const urlParams = new URLSearchParams(queryString);
//     const encodedData = urlParams.get('data') || null;
//     const decryptedData = encodedData ? CryptoJS.AES.decrypt(decodeURIComponent(encodedData), secret).toString(CryptoJS.enc.Utf8) : null;
//     const parsedData = decryptedData && JSON.parse(decryptedData);
//     parsedData && setPaymentData(parsedData);
//     console.log(parsedData, "parseData")

//     let invst_type = JSON.parse(localStorage.getItem('transactionType'))
//     if(invst_type?.type){
//         console.log("transaction update")
//         if(parsedData && parsedData?.status == "Success"){
//             const apiClient = new ApiClient()
//             apiClient.fetchData(AppConfig.api.Login.transaction , "POST",{
//                 client_id : user?.client_id,
//                 mobile_no : localStorage.getItem("mobile"),
//                 orderId : parsedData?.orderid,
//                 investmentType : invst_type?.type || null
//             }).then(response =>{
//                 console.log(response)
//             })
//             .catch(e=>{
//                 console.log(e)
//             })
//         }
//     }
    

//     if (parsedData && (parsedData.status === 'Success' || parsedData.status === 'Failure')) {
//         parsedData.status === 'Success' ? setPaymentSuccess(true) : setPaymentSuccess(false);
//         setPaymentOrderId(parsedData.orderid);
//         parsedData.trackingId && setPaymentTxId(parsedData.trackingId);
//         parsedData.message && setPaymentTxId(parsedData.message);
//         setPaymentAmount(parsedData.amount);
//         //   parsedData.status === 'Success' && callRecieptEntry(parsedData);
//         //   localStorage.removeItem("cryptoSecret")
//         AppConfig.removeQueryParams();
//     }
// };

    const [card, setCard] = useState("")
    const [userId, setUserId] = useState("")
    const [userInfo , setUserInfo] = useState("")
    const [modal, setModal] = useState(false)
    const [userBanks, setUserBanks] = useState([])
    const [selectedBank, setSelectedBank] = useState([])
    const [paymentMode, setPaymentMode] = useState("upi")
    const [razorKey, setRazorKey] = useState("")
    const [cryptoSecret, setCryptoSecret] = useState("")
    const [paymentOrderId, setPaymentOrderId] = useState("")
    const [paymentErrorMessage, setPaymentErrorMessage] = useState("");
    const [paymentTxId, setPaymentTxId] = useState("");
    const [paymentSuccess, setPaymentSuccess] = useState(false)
    const [paymentFailure, setPaymentFailure] = useState(false)
    const [paymentAmount, setPaymentAmount] = useState("")
    const [paymentData, setPaymentData] = useState("")
    const [confirmPayment , setConfirmPayment] = useState(false)
    const [investmentType , setInvestmentType] = useState({})
    const [loader , setLoader] = useState(false)

    const [accounts, setAccounts] = useState([])
       const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    // const paymentData1 = decodeURIComponent(urlParams.get("data"), "base64");

    const safeDecrypt = (cipherText, key) => {
        try {
            const bytes = CryptoJS.AES.decrypt(cipherText, key);
            const decrypted = bytes?.toString(CryptoJS.enc.Utf8);
            if (!decrypted) return null; // Handle empty decryption (wrong key or bad data)
            return JSON.parse(decrypted);
        } catch (e) {
            console.error("Decryption failed:", e);
            return null;
        }
    };

    const storedData = localStorage.getItem("data");
    console.log("localstoredData", storedData)
    const decryptedData = storedData ? safeDecrypt(storedData, process.env.REACT_APP_SECRET_KEY) : null;
    console.log("decryptedData", decryptedData)

    const [investAmmount, setInvestAmount] = useState(decryptedData ? {
        energetic: decryptedData.energitic,
        traditional: decryptedData.traditional
    } : {});

    const [amount, setAmount] = useState("0")
    const [amount1,setAmount1] = useState("0")
    const [errMessage,setErrMessage] = useState("")

    const navigate = useNavigate()

    const handlePayment = () => {
        console.log("hit")
        localStorage.setItem("transactionType", JSON.stringify(investmentType))
        const mobile = localStorage.getItem("mobile");
        const account = JSON.parse(localStorage.getItem("accounts"));
        const amt = amount != 0 ? amount : JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('data'), process.env.REACT_APP_SECRET_KEY).toString(CryptoJS.enc.Utf8))?.subscription_fee
        console.log(mobile, account)
        try {
            const apiClient = new ApiClient(localStorage.getItem("token"));
            let url = AppConfig.api.Payment.payOrder;
            const payload1 = {
                mobileno: mobile,
                emailid: account[0]?.emailid,
                client_id: account[0]?.client_id,
                pushtype: 1,
                plan: {
                    "wealth_vault": {
                        "subscribed": true,
                        "amount": amt,
                    }
                },
                amount: (parseInt(amt) + amt * 0.18).toFixed(2),
                source:"wealth_vault"
            }

            const notesPayload = {
                source: "wealth_vault",
                clientid: account[0]?.client_id,

            };

            console.log("payload", payload1, "notespayload", notesPayload)

            console.log("url", url)


            apiClient
                .fetchData(url, "POST", payload1)
                .then((response) => {
                    console.log("response", response)
                    console.log(response);
                    if (
                        response &&
                        response.status === 200
                    ) {
                        let callback_url = `${AppConfig.api.Payment.payStatus}` + response.orderid
                        let mobilenum = `+91${mobile}`
                        const options = {
                            key: response?.orderkey,
                            amount: parseInt(`${amt}`),
                            currency: "INR",
                            name: "Tradeboss",
                            description: "plans",
                            order_id: response?.orderid,
                            redirect: true,
                            callback_url: callback_url,
                            notes: notesPayload,
                            method: {
                                netbanking: true,
                                card: true,
                                wallet: false,
                                upi: true
                            },
                            prefill: {
                                "email": payload1?.emailid,
                                "contact": mobilenum,
                            },
                            "modal": {
                                "ondismiss": function () {

                                }
                            }
                        };
                        console.log(options, "options")
                        const paymentObject = new window.Razorpay(options);
                        console.log(paymentObject, "payment")
                        paymentObject.on('payment.failed', function (response) {
                            console.log(response, "failure")
                            setPaymentOrderId(response.error.metadata.order_id);
                            setPaymentErrorMessage(response.error.reason);
                            setPaymentFailure(true)
                        });
                        paymentObject.open();
                    }
                })
                .catch((error) => {
                    console.log(error);
                });


        } catch (error) {
            console.error("Error fetching holding data:", error);
        }
    }
    useEffect(() => {
        setPaymentStatusModel();
    }, [handlePayment])

    const setPaymentStatusModel = () => {
        console.log("payment status model");
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const screenType = urlParams.get("screen") || null;

        if (screenType === "plan") {
            // setScreen("plan");
        }

        const encodedData = urlParams.get("data") || null;
        const paymentData = decodeURIComponent(encodedData, "base64");
        console.log("encodedData", encodedData)
        try {

            const decrypted = CryptoJS.AES.decrypt(paymentData,"96358214256984120")?.toString(CryptoJS.enc.Utf8);
            console.log("decrypted", decrypted)
            const parsedData = JSON.parse(decrypted);
            console.log("parsedData", parsedData)
            if (!parsedData) {
                console.error("Decryption failed or returned empty string. Possible wrong key or invalid data.");
            } else {
                console.log("decryptedData", parsedData.order_status);
                // if (parsedData && parsedData?.order_status === "Failed") {
                //     console.log("paymentFailure")
                //     setPaymentFailure(true)
                //     setPaymentOrderId(parsedData?.orderid);
                //     setPaymentTxId(parsedData.tracking_id)
                //     setPaymentAmount(parsedData?.amount);
                // }

                if (parsedData.order_status === 'Success') {
                    console.log("success")
                    setPaymentSuccess(true)
                    parsedData.trackingId && setPaymentTxId(parsedData.trackingId);
                    setPaymentAmount(parsedData.amount);
                    navigate1("/dashboard")
                    AppConfig.removeQueryParams();
                  
                } else if (parsedData.order_status === 'Failed') {
                    console.log("Failed")
                    setPaymentSuccess(false)
                    setPaymentFailure(true)
                    setPaymentOrderId(parsedData?.orderid)
                    navigate1("/accounts")
                    AppConfig.removeQueryParams();
                   
                }

                // if (parsedData && (parsedData.status === 'Success' || parsedData.status === 'Failure')) {
                //     parsedData.status === 'Success' ? setPaymentSuccess(true) : setPaymentSuccess(false);
                //     setPaymentOrderId(parsedData.orderid);
                //     parsedData.trackingId && setPaymentTxId(parsedData.trackingId);
                //     parsedData.message && setPaymentTxId(parsedData.message);
                //     setPaymentAmount(parsedData.amount);
                //     //   parsedData.status === 'Success' && callRecieptEntry(parsedData);
                //     //   localStorage.removeItem("cryptoSecret")
                //     AppConfig.removeQueryParams();
                // }
            }
        } catch (err) {
            console.error("Error during decryption:", err.message);
        }
    }

    console.log("users",user)

    useEffect(()=>{
        if(!localStorage.getItem("token")){
            navigate("/")
        }
    },[])

    // useEffect(() => {

    //     if(window.location.pathname == "/dashboard" || window.location.pathname == "/investment_type" ){
    //     const apiClient = new ApiClient(localStorage.getItem("token"))

    //     apiClient.fetchData(AppConfig.api.Subscription.bankList, "POST",
    //         {
    //             "mobileno" : localStorage.getItem("mobile"),
    //             "client_id": user?.client_id,
    //         })
    //         .then((response) => {
    //             if (response) {
    //                 let responseData = response
    //                 if (Array.isArray(responseData) && responseData.length > 0) {
    //                     console.info(`setUserBanks ${responseData}`);
    //                     setUserBanks(responseData);
    //                     if (responseData.length == 1) {
    //                         setSelectedBank(responseData[0])
    //                     }
    //                     else if (responseData.find(ele => ele.Default_Ac == "Yes")) {
    //                         const defaultBank = responseData?.length > 0 && responseData.find(ele => ele.Default_Ac == "Yes")
    //                         setSelectedBank(defaultBank)
    //                     } else {
    //                         setSelectedBank(responseData[0])
    //                     }
    //                 }
    //             }
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });

    //     }
    // }, [window.location.pathname])

    
    
    
    const AppTheme = createTheme({
        components : {
        MuiAutocomplete: {
            styleOverrides: {
              padding : "0px 0px",
              option : {
                backgroundColor : "#ffffff",
                color : "#000000",
                "&.MuiAutocomplete-option" : {
                  backgroundColor : "#ffffff !important"
                },
                "&.Mui-focused" : {
                  backgroundColor : "#F3D45E !important",
                },
              },
              root: {
                '&.Mui-selected': {
                  color: '#ffffff',
                  backgroundColor: '#000000',
                },
                ".css-1huaqfz-MuiFormLabel-root-MuiInputLabel-root" :{
                    color: '#F3D45E !important',
                },
                "& .MuiAutocomplete-input" : {
                    color : "white !important"
                },
                height : "100px"
              },
            }
          },
        }
    })

    const handlePaymentModeChange = (e) => {
        setPaymentMode(e.target.value)
    }

    console.log(paymentMode, selectedBank, amount)

    const handleBankChange = (e, newvalue) => {
        setSelectedBank(newvalue)
    }
    
//     const handlePayment = () => {
//         console.log("payment")
//         localStorage.setItem("transactionType",JSON.stringify(investmentType))
//       try {
//           const apiClient = new ApiClient(localStorage.getItem("token"));
//         //   if (!selectedBank) {
//         //       return alert("please select a bank")
//         //   }
//         //   if (!amount) {
//         //       return alert("please enter amount")
//         //   }
//         //   if (parseFloat(amount.replaceAll(",", "")) < 1) {
//         //       return alert("min amount should be 1")
//         //   }

//         //   if (paymentMode === "netbanking") {
//         //       if (parseFloat(amount.replaceAll(",", "")) > 10000000) {
//         //           return alert("Maximum  amount allowed is Rs 1,00,00,000.00");
//         //       }
//         //   } else {
//         //       if (parseFloat(amount.replaceAll(",", "")) > 200000) {
//         //           return alert("Maximum  amount allowed is Rs 2,00,000.00");
//         //       }
//         //   }



//           setModal(false)
//           let url = ""
//           let finalAmount = 0 
//           if(window.location.pathname === "/accounts"){
//             url = AppConfig.api.Subscription.subscription
//             finalAmount = (parseInt(amount) + (amount * 0.18)).toFixed(2) //adding GST only for subscription amount, dev-Ayush 13-02-2025
//           }else{
//             url = AppConfig.api.Payment.payOrder
//             finalAmount = amount // without GST, dev-Ayush 13-02-2025
//           }
          
//           apiClient.fetchData(
//               url,
//               "POST",
//               {
//                   "mobileno":selectedBank.MOBILE_NO,
//                   "client_id":selectedBank?.Account_Code,
//                   "amount": finalAmount, //final amount dev-Ayush 13-02-2025
//                   "paymentMode":paymentMode,
//                   "accountNumber":selectedBank.Bank_AcNo,
//                   "bankname":selectedBank.Bank_Name,
//                   "ifsc":selectedBank.IFSC_Code,
//                   "upiid":selectedBank.UPIBANKID
//               }
//           )
//               .then((response) => {
//                   console.info(response);
//                   if (response && response.status == 200 && response.hasOwnProperty("orderId")) {

//                       // response.cryptoSecret && setCryptoSecret(response.cryptoSecret);
//                       // setCryptoSecret(response.cryptoSecret)
//                       setPaymentStatusModel(response.cryptoSecret);
//                       localStorage.setItem("cryptoSecret",response.cryptoSecret)

//                       const methodsObj = AppConfig.paymentGateWay.methodsObj[paymentMode];
//                       console.info(methodsObj);
//                       const options = {
//                           key: response?.key, // Enter the Key ID generated from the Dashboard
//                           amount: finalAmount, //final amount  dev-Ayush 13-02-2025
//                           currency: AppConfig.paymentGateWay.currency,
//                           name: AppConfig.paymentGateWay.name,
//                           description: "Add Funds",
//                           method: paymentMode,
//                           order_id: response.orderId,
//                           redirect: true,
//                           callback_url: `${AppConfig.api.Payment.payStatus}?orderId=${response.orderId}&userId=${selectedBank?.Account_Code}`,
//                           // handler: async function (response1) {
//                           //     this.getaxis(response1)
//                           // },
//                           options: {
//                               checkout: {
//                                   method: {
//                                       // "netbanking": 1, // check it according to the user selection 
//                                       // "card":1,
//                                       // "upi":0,
//                                       // "wallet":0
//                                   }
//                               }
//                           },
//                           prefill: {
//                               contact: selectedBank.MOBILE_NO,
//                               method: 'upi',
//                               flow: "collect",
//                               vpa: selectedBank.UPIBANKID
//                           },
//                           theme: {
//                               color: AppConfig.paymentGateWay.theme.color,
//                           },
//                       };
//                       switch (paymentMode) {
//                           case 'netbanking':
//                               options.options.checkout.method.netbanking = 1;
//                               break;
//                           case 'upi':
//                               options.options.checkout.method.upi = 0;
//                               break;
//                       };
//                       const paymentObject = new window.Razorpay(options);
//                       paymentObject.on('payment.failed', function (response) {
//                           console.log(response, "failure")
//                           setPaymentOrderId(response.error.metadata.order_id);
//                           setPaymentErrorMessage(response.error.reason);
//                           setPaymentFailure(true)
//                       });

//                       paymentObject.on('order.paid', function (response) {
//                           alert(response)
//                       });
//                       paymentObject.open();
//                       setLoader(false)
//                   }
//               })
//               .catch((error) => {
//                   console.log(error);
//               });
//       } catch (error) {
//           console.error('Error fetching holding data:', error);
//       }
//   }




    return(
        <ThemeProvider theme={AppTheme}>
        <Container className={styles.container1}>
            <AppBar elevation={0} position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 , height : "65px !important" , background : "#0B1420 !important" }}>
                    <Container className={styles.container1}  >
                        <Toolbar disableGutters >
                            <Box className={styles.appBarTitleBox} sx={{display : "flex" , justifyContent : "space-between" , alignItems : "center"}} width="100%">
                                <img src={navLogo} 
                                    className={styles.navLogo}
                                     />
                                {window.location.pathname === "/dashboard" && <IconButton onClick={()=>{
                                    localStorage.clear()
                                    navigate("/")
                                    }}>
                                    <ExitToAppIcon sx={{fontSize : "32px" , marginRight :"20px" , color : "white"}}/>
                                </IconButton>}
                            </Box>
                        </Toolbar>
                    </Container>
                </AppBar>
            <Grid2 sx={{marginTop : "64px"}}>
            { window.location.pathname == "/" && <Login setUser = {setUser} setAccounts={setAccounts} setAmount={setAmount} investAmmount = {investAmmount} setInvestAmount = {setInvestAmount}/>}
            { window.location.pathname == "/dashboard" &&  
            <Dashboard
            setPaymentStatusModel = {setPaymentStatusModel}
            paymentAmount ={paymentAmount} 
            paymentTxId = {paymentTxId} 
            paymentSuccess = {paymentSuccess}
            paymentOrderId ={paymentOrderId}
            setPaymentFailure ={setPaymentFailure}
            setPaymentSuccess ={setPaymentSuccess}
            paymentErrorMessage ={paymentErrorMessage}
            setModal ={setModal}
            setInvestmentType ={setInvestmentType}
            setPaymentMode ={setPaymentMode}
            paymentMode ={paymentMode}
            selectedBank ={selectedBank}
            setSelectedBank ={setSelectedBank}
            setUserBanks ={setUserBanks}
            paymentFailure ={paymentFailure}
            card ={card}
            setCard ={setCard}
            modal ={modal}
            investmentType  ={investmentType}
            amount ={amount}
            setConfirmPayment ={setConfirmPayment}
            confirmPayment ={confirmPayment}
            userBanks ={userBanks}
            handlePayment = {handlePayment}
            setPaymentOrderId = {setPaymentOrderId}
            user = {user}
            handlePaymentModeChange = {handlePaymentModeChange} 
            handleBankChange = {handleBankChange}
            setAmount={setAmount}
            setAmount1={setAmount1}
            investAmount = {investAmmount}
            loader = {loader}
             />} 

            
            { window.location.pathname == "/accounts" && 
             <Accounts accounts={accounts} amount={amount}
            handlePayment = {handlePayment}
            handlePaymentModeChange = {handlePaymentModeChange} 
            handleBankChange = {handleBankChange}
            paymentErrorMessage ={paymentErrorMessage}
            paymentFailure ={paymentFailure}
            setPaymentFailure ={setPaymentFailure}
            userBanks = {userBanks}
            setUserBanks = {setUserBanks}
            paymentMode = {paymentMode}
            setPaymentMode = {setPaymentMode} 
            paymentOrderId ={paymentOrderId}
            setPaymentOrderId = {setPaymentOrderId}
            setSelectedBank = {setSelectedBank}
            selectedBank = {selectedBank}
            setUser = {setUser}
            setAmount={setAmount}
            setAmount1={setAmount1}
            />}
            { window.location.pathname == "/investment_type" &&  <Card setCard={setCard} setModal={setModal} handlePaymentModeChange = {handlePaymentModeChange} handleBankChange = {handleBankChange} investmentType = {investmentType}   setAmount={setAmount}
            investAmount = {investAmmount}/>}
            </Grid2>

            <Modal open={modal} onClose={() => {
                setErrMessage("")
                setConfirmPayment(false)
                setModal(false)}} sx={{ border: "none" }}
                    BackdropProps={{
                        style: {
                            background: "#18102ECC",
                        },
                    }}>
                <Box
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: smallScreen ? "80%" : "555px" ,
                        height: "505px",
                        overflowY: "auto",
                        outline: "none",
                        background: "#FFFFFF",
                        p: 4,
                        borderRadius: "16px",
                        padding: "10px 25px 0px 25px",
                        justifyContent: "center",
                        alignItems: "center",
                        "@media only screen and (max-device-width: 480px)": {
                            width: "90%",
                            height: "480px !important",
                        },
                    }}
                >
                    <Grid2 className={styles1.paymentPopUp} >
                        <Grid2 sx={{ display: "flex", justifyContent: "space-between", ml: smallScreen1 && "5%" || smallScreen && "10%" || "105px" }} >
                                <img src={cardlogo} height={ smallScreen2 ? 87 : 111} style={{marginTop : smallScreen1 && "0px" }}/>
                            <Grid2 sx={{ ml: "8px",mt:"24px"
                                    , "@media only screen and (max-device-width: 500px)": {
                                        mt: "5px"
                                    },
                             }}>
                                <Typography className={styles1.modalheading}>{investmentType?.type}</Typography>
                                <Typography className={styles1.paymentText1}>{investmentType?.risk}</Typography>
                            </Grid2>
                        </Grid2>
                        <IconButton onClick={() => {
                            setErrMessage("")
                setConfirmPayment(false)
                setModal(false)}}>
                            <CloseIcon sx={{ color: "black",pt:"18px",
                                    "@media only screen and (max-device-width: 500px)": {
                                        pt: "8px",
                                    },
                             }} />
                        </IconButton>
                    </Grid2>
                    
                    {!confirmPayment ? <Grid2 sx={{ ml: smallScreen1 && "6%" || smallScreen && "10%" || "105px" ,"@media (max-width : 385px)" : {
                        ml : "10px !important"
                    } }}>
                        <Typography className={styles1.paymentText2}>Payment method</Typography>
                        <FormControl>
                            <RadioGroup
                                sx={{marginTop :"10px"}}
                                aria-labelledby="demo-radio-buttons-group-label"
                                value={paymentMode}
                                name="radio-buttons-group"
                                onChange={handlePaymentModeChange}
                                row
                            >
                                <FormControlLabel value="upi" control={<Radio sx={{
                                    color: "#000000",
                                    '&.Mui-checked': {
                                        color: "#000000",
                                    },
                                }} />} label={<Typography className={styles1.paymentText} sx={{fontSize : "16px !important"}}>UPI</Typography>} />
                                <FormControlLabel value="netbanking" control={<Radio sx={{
                                    color: "#000000",
                                    '&.Mui-checked': {
                                        color: "#000000",
                                    },
                                }} />} label={<Typography className={styles1.paymentText} sx={{fontSize : "16px !important"}}>Net Banking</Typography>} />

                            </RadioGroup>
                        </FormControl>
                        <Typography className={styles1.paymentText3}>Select Bank Account</Typography>
                        {/* <Autocomplete/> */}
                        <Autocomplete
                        
                        disablePortal
                        id="combo-box-demo"
                        options={userBanks || []}
                        value={selectedBank}
                        onChange={handleBankChange}
                        getOptionLabel={(option) => paymentMode === "upi" ? (`${option.Bank_Name} - ${option.UPIBANKID || 'No Upi Id'}`) : (`${option.Bank_Name} - ${option.Bank_AcNo}`)}
                        
                        size='small'
                        
                            sx={{
                                marginTop: "10px",
                                width: smallScreen1 ? "280px !important" : "335px !important",
                                height: "40px",
                                borderRadius: "5px",
                                backgroundColor: "#FFFFFF",
                                '.MuiInputBase-input': {
                                    color: 'black !important',
                                }

                        }}
                        renderInput={(params) => <TextField  {...params}  />}
                    />
                    {errMessage.includes("bank") && <Typography sx={{color : "red",fontSize : "14px"}}>{errMessage}</Typography>}
                        <Typography className={styles1.paymentText3}>Investment Amount </Typography>
                        <TextField
  className={styles1.textField}
  size="small"
  value={amount ? Number(amount).toLocaleString('en-IN') : ''}
  onChange={(e) => {
    const rawVal = e.target.value.replace(/,/g, '');
    if (/^\d*$/.test(rawVal)) {
      setAmount(rawVal);
    }
  }}
  type="text"
  id="outlined-basic"
  variant="outlined"
  InputProps={{
    startAdornment: (
      <InputAdornment sx={{ marginRight: "1px", marginTop : "1.5px", fontWeight: 'bold', color: '#000' }} position="start">₹</InputAdornment>
    ),
  }}
  onWheel={(e) => e.target.blur()}
/>
                            {!errMessage.includes("bank") && <Typography sx={{color : "red",fontSize : "14px"}}>{errMessage}</Typography>}
                             
                            
                             <Button className={styles1.loginbutton} sx={{width : smallScreen1 ? "280px !important" : "335px !important"}} onClick={()=>{
                                if (!selectedBank) {
                                    return setErrMessage("please select a bank")
                                }
                                if(amount.trim() === ""){
                                    return setErrMessage(`Please Enter some amount`)
                                }
                                if(paymentMode == "upi" && parseInt(amount) > 200000){
                                    return setErrMessage(`Max Amount for upi is 2,00,000`)
                                }
                                if(parseInt(amount) > 10000000){
                                    return setErrMessage(`Max investment Amount is 1 crore`)
                                }
                                if(parseInt(amount) < parseInt(amount1) ){
                                    return setErrMessage(`Minimum investment Amount is Rs ${Number(amount1).toLocaleString('en-IN')}`)
                                }else{
                                    setErrMessage("")
                                    setConfirmPayment(true)
                                }
                                }}>Buy Now</Button>
                    </Grid2>:

                    <Grid2 sx={{ display : "flex" , justifyContent : "center" , flexDirection : "column" , alignItems : "center" }}>
                        <Typography className={styles1.paymentText2} sx={{fontSize : "20px !important" , mt : "20px !important"}}>Investment Amount</Typography>
                        <Typography className={styles1.paymentText2} sx={{fontSize : "32px !important"}}>₹{Number(amount).toLocaleString('en-IN')}</Typography>
                        <Typography className={styles1.paymentText3} sx={{fontSize : "16px !important", textAlign : "center" , width : "350px"}} >Orders cannot be cancelled after they are placed.</Typography>
                                <Button className={styles1.loginbutton} sx={{ width: smallScreen1 ? "280px !important" : "335px !important" }} onClick={()=>{
                            setLoader(true)
                            setConfirmPayment(false)
                            setModal(false)
                            localStorage.setItem("paymentType","portfolio")
                            handlePayment()
                            }}> {loader ? <CircularProgress/> : "Confirm" }</Button>
                        
                    </Grid2>}
                </Box>
            </Modal>    
        </Container>
        </ThemeProvider> 
)
} 